import * as Yup from "yup";
import { ERROR_MSG } from "../../constants/messages";

export const accountBasisValidationSchema = Yup.object({
  email: Yup.string()
    .email(ERROR_MSG.email)
    .matches(/^[\w-.]+@([\w-]+\.)+[\w-]{2,63}$/, ERROR_MSG.email)
    .required(ERROR_MSG.required),
  telefonMobilNr: Yup.string()
    .required(ERROR_MSG.required)
    .matches(/^\d{8}$/, "Indtast et gyldigt dansk telefonnummer (8 cifre)."),
});
